var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_9767)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 23.5373L28.8382 32.3757C29.3072 32.8447 29.9433 33.1081 30.6066 33.1081C31.2698 33.1081 31.9059 32.8447 32.3749 32.3757C32.8439 31.9067 33.1074 31.2706 33.1074 30.6073C33.1074 29.9441 32.8439 29.308 32.3749 28.839L23.5332 20.0007L32.3732 11.1623C32.6054 10.9301 32.7895 10.6545 32.915 10.3511C33.0406 10.0477 33.1052 9.72258 33.1051 9.39425C33.105 9.06592 33.0403 8.74081 32.9146 8.4375C32.7889 8.13419 32.6046 7.85862 32.3724 7.62651C32.1402 7.39439 31.8645 7.21029 31.5612 7.08472C31.2578 6.95914 30.9327 6.89455 30.6043 6.89463C30.276 6.8947 29.9509 6.95945 29.6476 7.08517C29.3443 7.21089 29.0687 7.39512 28.8366 7.62734L19.9999 16.4657L11.1616 7.62734C10.9311 7.38846 10.6553 7.19787 10.3504 7.06671C10.0454 6.93555 9.71739 6.86643 9.38544 6.86339C9.0535 6.86035 8.72427 6.92345 8.41697 7.049C8.10967 7.17456 7.83046 7.36006 7.59562 7.59468C7.36077 7.8293 7.17501 8.10834 7.04916 8.41552C6.92332 8.7227 6.85991 9.05187 6.86263 9.38382C6.86536 9.71577 6.93417 10.0438 7.06505 10.3489C7.19592 10.654 7.38625 10.9299 7.62491 11.1607L16.4666 20.0007L7.62658 28.8407C7.38791 29.0714 7.19759 29.3474 7.06671 29.6524C6.93584 29.9575 6.86703 30.2856 6.8643 30.6175C6.86157 30.9495 6.92498 31.2786 7.05083 31.5858C7.17668 31.893 7.36244 32.172 7.59728 32.4067C7.83212 32.6413 8.11134 32.8268 8.41864 32.9523C8.72594 33.0779 9.05516 33.141 9.38711 33.138C9.71905 33.1349 10.0471 33.0658 10.352 32.9346C10.657 32.8035 10.9327 32.6129 11.1632 32.374L19.9999 23.5373Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_9767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteCloseFill);
export default __webpack_public_path__ + "static/media/mingcute_close-fill.455321d8c9d031554ce5501b67df266c.svg";
export { ForwardRef as ReactComponent };